// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".personalization-settings #content input[data-v-02c8bd12] {\n  color: #495057;\n  border: 1px solid #ced4da;\n  background-color: #fff;\n}\nh4[data-v-02c8bd12], p[data-v-02c8bd12] {\n  font-size: 15px;\n}\nh4[data-v-02c8bd12] {\n  font-weight: 600;\n}\nh4 svg[data-v-02c8bd12] {\n    cursor: pointer;\n}\n[data-v-02c8bd12] .dropdown .btn-secondary:hover {\n  color: #b9b9b9;\n}\n", ""]);
// Exports
module.exports = exports;
